import { combineReducers } from 'redux';

import abacus from './modules/abacus';
import content from './modules/content';
import intl from './modules/intl';
import renderOptions from './modules/renderOptions';
import system from './modules/system';
import user from './modules/user';
import login from './modules/login';
import propertyTypeImages from './modules/propertyTypeImages';
import recommendedProperties from './modules/recommendedProperties';
import recommendedDestinations from './modules/recommendedDestinations';

export default combineReducers({
  abacus,
  content,
  intl,
  renderOptions,
  system,
  user,
  login,
  propertyTypeImages,
  recommendedProperties,
  recommendedDestinations
});
